import { FormFieldWysiwyg } from '../../Form'
import { getFormikWysiwygErrorProps } from '../Formik.utils'
import { FormikField } from '../FormikField'

function FormikWysiwygField(props) {
  return (
    <FormikField
      {...props}
      Component={FormFieldWysiwyg}
      getErrorProps={getFormikWysiwygErrorProps}
    />
  )
}

export default FormikWysiwygField
